/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ayeri",
        "-2": "antayeri",
        "0": "güei",
        "1": "mañana",
        "2": "pasao mañana",
        "future": {
          "one": "en {0} día",
          "other": "en {0} díes"
        },
        "past": {
          "one": "hai {0} día",
          "other": "hai {0} díes"
        }
      },
      "day-narrow": {
        "-1": "ayeri",
        "-2": "antay.",
        "0": "güei",
        "1": "mañ.",
        "2": "p. mañ.",
        "future": {
          "one": "en {0} d.",
          "other": "en {0} d."
        },
        "past": {
          "one": "hai {0} d.",
          "other": "hai {0} d."
        }
      },
      "day-short": {
        "-1": "ayeri",
        "-2": "antayeri",
        "0": "güei",
        "1": "mañana",
        "2": "pasao mañana",
        "future": {
          "one": "en {0} día",
          "other": "en {0} díes"
        },
        "past": {
          "one": "hai {0} día",
          "other": "hai {0} díes"
        }
      },
      "hour": {
        "0": "esta hora",
        "future": {
          "one": "en {0} hora",
          "other": "en {0} hores"
        },
        "past": {
          "one": "hai {0} hora",
          "other": "hai {0} hores"
        }
      },
      "hour-narrow": {
        "0": "esta h.",
        "future": {
          "one": "en {0} h.",
          "other": "en {0} h."
        },
        "past": {
          "one": "hai {0} h.",
          "other": "hai {0} h."
        }
      },
      "hour-short": {
        "0": "esta hora",
        "future": {
          "one": "en {0} h.",
          "other": "en {0} h."
        },
        "past": {
          "one": "hai {0} h.",
          "other": "hai {0} h."
        }
      },
      "minute": {
        "0": "esti minutu",
        "future": {
          "one": "en {0} minutu",
          "other": "en {0} minutos"
        },
        "past": {
          "one": "hai {0} minutu",
          "other": "hai {0} minutos"
        }
      },
      "minute-narrow": {
        "0": "esti min.",
        "future": {
          "one": "en {0} min.",
          "other": "en {0} min."
        },
        "past": {
          "one": "hai {0} min.",
          "other": "hai {0} min."
        }
      },
      "minute-short": {
        "0": "esti min.",
        "future": {
          "one": "en {0} min.",
          "other": "en {0} min."
        },
        "past": {
          "one": "hai {0} min.",
          "other": "hai {0} min."
        }
      },
      "month": {
        "-1": "el mes pasáu",
        "0": "esti mes",
        "1": "el mes viniente",
        "future": {
          "one": "en {0} mes",
          "other": "en {0} meses"
        },
        "past": {
          "one": "hai {0} mes",
          "other": "hai {0} meses"
        }
      },
      "month-narrow": {
        "-1": "mes pas.",
        "0": "esti mes",
        "1": "mes vin.",
        "future": {
          "one": "en {0} m.",
          "other": "en {0} m."
        },
        "past": {
          "one": "hai {0} m.",
          "other": "hai {0} m."
        }
      },
      "month-short": {
        "-1": "mes pas.",
        "0": "esti mes",
        "1": "mes vin.",
        "future": {
          "one": "en {0} mes",
          "other": "en {0} meses"
        },
        "past": {
          "one": "hai {0} mes",
          "other": "hai {0} meses"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "trimestre anterior",
        "0": "esti trimestre",
        "1": "trimestre viniente",
        "future": {
          "one": "en {0} trimestre",
          "other": "en {0} trimestres"
        },
        "past": {
          "one": "hai {0} trimestre",
          "other": "hai {0} trimestres"
        }
      },
      "quarter-narrow": {
        "-1": "trim. ant.",
        "0": "esti trim.",
        "1": "trim. vin.",
        "future": {
          "one": "en {0} tr.",
          "other": "en {0} tr."
        },
        "past": {
          "one": "hai {0} tr.",
          "other": "hai {0} tr."
        }
      },
      "quarter-short": {
        "-1": "trim. ant.",
        "0": "esti trim.",
        "1": "trim. vin.",
        "future": {
          "one": "en {0} trim.",
          "other": "en {0} trim."
        },
        "past": {
          "one": "hai {0} trim.",
          "other": "hai {0} trim."
        }
      },
      "second": {
        "0": "agora",
        "future": {
          "one": "en {0} segundu",
          "other": "en {0} segundos"
        },
        "past": {
          "one": "hai {0} segundu",
          "other": "hai {0} segundos"
        }
      },
      "second-narrow": {
        "0": "agora",
        "future": {
          "one": "en {0} s.",
          "other": "en {0} s."
        },
        "past": {
          "one": "hai {0} s.",
          "other": "hai {0} s."
        }
      },
      "second-short": {
        "0": "agora",
        "future": {
          "one": "en {0} seg.",
          "other": "en {0} seg."
        },
        "past": {
          "one": "hai {0} seg.",
          "other": "hai {0} seg."
        }
      },
      "week": {
        "-1": "la selmana pasada",
        "0": "esta selmana",
        "1": "la selmana viniente",
        "future": {
          "one": "en {0} selmana",
          "other": "en {0} selmanes"
        },
        "past": {
          "one": "hai {0} selmana",
          "other": "hai {0} selmanes"
        }
      },
      "week-narrow": {
        "-1": "selm. pas.",
        "0": "esta selm.",
        "1": "selm. vin.",
        "future": {
          "one": "en {0} se.",
          "other": "en {0} se."
        },
        "past": {
          "one": "hai {0} se.",
          "other": "hai {0} se."
        }
      },
      "week-short": {
        "-1": "selm. pasada",
        "0": "esta selm.",
        "1": "selm. viniente",
        "future": {
          "one": "en {0} selm.",
          "other": "en {0} selm."
        },
        "past": {
          "one": "hai {0} selm.",
          "other": "hai {0} selm."
        }
      },
      "year": {
        "-1": "l’añu pasáu",
        "0": "esti añu",
        "1": "l’añu viniente",
        "future": {
          "one": "en {0} añu",
          "other": "en {0} años"
        },
        "past": {
          "one": "hai {0} añu",
          "other": "hai {0} años"
        }
      },
      "year-narrow": {
        "-1": "añu pas.",
        "0": "esti añu",
        "1": "añu vin.",
        "future": {
          "one": "en {0} a.",
          "other": "en {0} a."
        },
        "past": {
          "one": "hai {0} a.",
          "other": "hai {0} a."
        }
      },
      "year-short": {
        "-1": "l’añu pas.",
        "0": "esti añu",
        "1": "l’añu vin.",
        "future": {
          "one": "en {0} añu",
          "other": "en {0} años"
        },
        "past": {
          "one": "hai {0} añu",
          "other": "hai {0} años"
        }
      }
    },
    "locale": "ast"
  });
}